import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';


const CustomerCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [gstError, setGstError] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        Name: '',
        Address1: '',
        Address2: '',
        Contact1: '',
        Contact2: '',
        Email: '',
        GSTNo: '',
        Location: '',
        Pincode: '',
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };
        setFormData(updatedFormData);
    };

    const submitData = async () => {
        try {
            // Fetch existing data
            const existingItems = await fetchData('CustomerApi', `/${companyId}`, token);//, token
            console.log('Existing Items:', existingItems);

            if (
                existingItems.response_data &&
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Name === formData.Name && item.GSTNo === formData.GSTNo && item.Contact1 == formData.Contact1
                )
            ) {
                alert('Item with the same Name already exists.');
                return;
            }

            // Validate form data
            if (!formData.Name) {
                alert('Name is required.');
                return;
            }

            if (!formData.Contact1) {
                alert('Contact 1 is required.');
                return;
            }

            if (!formData.Address1) {
                alert('Address 1 is required.');
                return;
            }

            // Submit data
            const response = await postData('CustomerApi', formData, token); //, token
            console.log('Data Created success:', response);

            history.push('/CustomerIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-25px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Customer</h6>
                
                    <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0, marginTop: '-10px' }}>
                        {/* Save Button */}
                        <Button
                            variant="contained"
                            onClick={submitData}
                            disabled={isLoading}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#1E3A8A", // deep ERP-blue
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save"}
                        </Button>

                        {/* Back To List Button */}
                        <Button
                            variant="contained"
                            component={Link}
                            to="/CustomerIndex"
                            className="linkcolor"
                            onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{
                                height: "25px",
                                minWidth: "90px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F4F6", // light gray ERP style
                                color: "#1E3A8A",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                        >
                            Back To List
                        </Button>
                    </div>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                        <div className="w-full mb-3 flex" >

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Contact 1<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Contact1}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Contact No 1"
                                    name='Contact1'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Contact 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Contact2}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Contact No 2"
                                    name='Contact2'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                        </div>
                        <div className="w-full mb-3 flex" >
                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Email
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Email}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Email"
                                    name='Email'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    GST No
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTNo}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GST No"
                                    name='GSTNo'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Site
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Location}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Site"
                                    name='Location'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Pincode
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Pincode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Pin Code"
                                    name='Pincode'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                        <div className="w-full mb-3 flex" >
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Address 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Address1}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Address Line 1"
                                    name='Address1'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Address 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Address2}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Address Line 2"
                                    name='Address2'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                    </div>

                </div>

            </div >
        </Fragment >
    );
};

export default CustomerCreate;

